import {useCallback} from "react";
import {debounce} from "./debounce";

/**
 *
 * @param callback      function to be called
 * @param params        useCallback params
 * @param delay         debounce delay
 * @param rawFunction   function to be called as raw function before debounce
 * @returns {(function(): void)|*}
 */
export const useDebounceCallback = (callback, params, delay, rawFunction = null) => {
    return useCallback(
        (...p) => {
            if(rawFunction && typeof rawFunction === 'function') {
                rawFunction(...p);
            }
            debounce(callback, delay)(...p)
        },
        params
    );
}
